import { render, staticRenderFns } from "./MiniBanner.vue?vue&type=template&id=c881b922&scoped=true"
import script from "./MiniBanner.vue?vue&type=script&lang=js"
export * from "./MiniBanner.vue?vue&type=script&lang=js"
import style0 from "./MiniBanner.vue?vue&type=style&index=0&id=c881b922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c881b922",
  null
  
)

export default component.exports